export default {
  state: {
    currentLink: { name: 'Overview', value: 'overview' },
    currentTab: 0,
    tabOnce: false,
  },
  mutations: {
    SET_CURRENT_LINK(state, link) {
      state.currentLink = link
    },
    SET_CURRENT_TAB(state, tab) {
      state.currentTab = tab
    },
    SET_TAB_ONCE(state, tab) {
      state.tabOnce = tab
    },
  },
  actions: {},
  getters: {
    GET_CURRENT_LINK(state) {
      return state.currentLink
    },
    GET_CURRENT_TAB(state) {
      return state.currentTab
    },
    GET_TAB_ONCE(state) {
      return state.tabOnce
    },
  },
}
